import React, { useEffect, useState } from 'react';
import {
  Box,
	Button,
  Dialog,
	Divider,
	IconButton,
	Typography,
	DialogTitle,
	DialogActions,
	DialogContent,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { useEditingProfileId } from '../../../../hooks/useEditingProfile';

import BaoCaoForm from '../BaoCaoForm/BaoCaoForm';

import { fileActions, reportsActions } from '../../../../actions';

export default function BaoCaoUpdate(props) {
	const dispatch = useDispatch();
  const profileId = useEditingProfileId();

	const [values, setValues] = useState(null);
	const [disabled, setDisabled] = useState(true);
	
	const handleSubmit = () => {
		if (values?.previewFile?.[0]) {
			dispatch(fileActions.importPreviewFile(profileId, values?.previewFile[0]))
			.then((response) => dispatch(reportsActions.updateReport({ ...values, preview: response })));
    } else {
			dispatch(reportsActions.updateReport(values));
    }
		props.onClose();
	}

	const handleEdit = () => {setDisabled(false)};

	const handleClose = () => {
		if (disabled) props.onClose(); else setDisabled(true);
	}

	useEffect(() => {
		setDisabled(true);
		setValues(props.detail);
	}, [props.detail]);

	return (
		<Dialog
			fullWidth
			maxWidth='sm'
			open={!!(props.detail)}
		>
			<DialogTitle style={{ padding: '4px 12px 4px 24px' }}>
				<Box display='flex' justifyContent='space-between' alignItems='center'>
					<Typography variant='h5'>Chi tiết báo cáo</Typography>
					<IconButton onClick={props.onClose}><Close /></IconButton>
				</Box>
			</DialogTitle>
			<Divider />
			<DialogContent>
				<BaoCaoForm
					id='bao-cao'
					values={values}
					disabled={props.acceptMode ? true : disabled}
					authorEditable={props.acceptMode}
					setValues={setValues}
					handleSubmit={handleSubmit}
				/>
			</DialogContent>
			<DialogActions style={{ padding: '8px 24px' }}>
				<Button variant='outlined' onClick={handleClose}>Huỷ</Button>
				{props.acceptMode ? (
					<Button variant='contained' color='secondary' onClick={handleSubmit}>Lưu</Button>
				) : disabled ? (
					<Button variant='outlined' color='secondary' onClick={handleEdit}>Chỉnh sửa</Button>
				) : (
					<Button variant='contained' color='secondary' onClick={handleSubmit}>Xác nhận</Button>
				)}
			</DialogActions>
		</Dialog>
	);
}